import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal, ModalBody } from 'reactstrap';
import GIF_LOADING from '../../images/kick.gif';

const ModalUploadImageSell = (props: { isOpen: boolean }) => {
  return (
    <Modal
      modalClassName="kick-notification-wrapper"
      isOpen={props.isOpen}
      className="kick-modal modal-upload-image-sell"
    >
      <ModalBody>
        <KickImage src={GIF_LOADING} />
        <p>Please wait, we are uploading your photos.</p>
      </ModalBody>
    </Modal>
  );
};

export default ModalUploadImageSell;
